function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
export class BarChartStackedLayout {}

_defineProperty(BarChartStackedLayout, "VALUE_LABEL_FONT_SIZE", 0.75);

_defineProperty(BarChartStackedLayout, "BAR_WIDTH", 1.25);

_defineProperty(BarChartStackedLayout, "BAR_HEIGHT", 1.25);

_defineProperty(BarChartStackedLayout, "MIN_BAR_DISTANCE_VERTICAL", 1.0);

_defineProperty(BarChartStackedLayout, "MIN_BAR_DISTANCE_HORIZONTAL", 0.25 + BarChartStackedLayout.VALUE_LABEL_FONT_SIZE + 0.875);

_defineProperty(BarChartStackedLayout, "MAX_BAR_DISTANCE", 20.0);

_defineProperty(BarChartStackedLayout, "REMAINDER_SEGMENT_BORDER_WIDTH", 1.0);
